import { forwardRef } from 'react'

import { SENTIMENT_BORDER } from './sentimentBorder'
import type { SentimentIconProps } from './types'

const FILL = 'var(--hsds-token-color-green-500, #47C47D)'
const PATH =
  'M2.34337 2.34315C5.46756 -0.781049 10.5329 -0.781049 13.6571 2.34315C16.7813 5.46734 16.7813 10.5327 13.6571 13.6569C10.5329 16.781 5.46756 16.781 2.34337 13.6569C-0.780824 10.5327 -0.780824 5.46734 2.34337 2.34315ZM4.46469 7.29289C4.07417 7.68342 4.07417 8.31658 4.46469 8.70711C4.85522 9.09763 5.48838 9.09763 5.8789 8.70711L7.00033 7.58568V10.8284C7.00033 11.3807 7.44794 11.8283 8.00022 11.8283C8.55248 11.8283 9.00012 11.3807 9.00012 10.8284V7.58568L10.1215 8.70711C10.5121 9.09763 11.1452 9.09763 11.5358 8.70711C11.9263 8.31658 11.9263 7.68342 11.5358 7.29289L8.70733 4.46447C8.31681 4.07394 7.68364 4.07394 7.29312 4.46447L4.46469 7.29289Z'

// Positive sentiment — green circle with an upward arrow. The `border`
// variant renders the same glyph in a 20×20 box behind a white border so it
// reads on colored backgrounds (mirrors the Figma `Border=True` asset).
const PositiveSentimentIcon = forwardRef<SVGSVGElement, SentimentIconProps>(
  function PositiveSentimentIcon({ border = false, ...rest }, ref) {
    if (border) {
      return (
        <svg
          ref={ref}
          width={20}
          height={20}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          {SENTIMENT_BORDER}
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            transform="translate(2 2)"
            d={PATH}
            fill={FILL}
          />
        </svg>
      )
    }

    return (
      <svg
        ref={ref}
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path fillRule="evenodd" clipRule="evenodd" d={PATH} fill={FILL} />
      </svg>
    )
  }
)

export { PositiveSentimentIcon }
